import { BaseRequest } from "./baseRequest";
import { ComparisonCommand } from "./commands";

export class ComparisonDataRequest extends BaseRequest {
    
  comparisonSessionId?: number;
  comparison?: ComparisonCommand;

}